(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-product-edit')) {
    customElements.define('featured-product-edit', class extends HTMLElement {
      connectedCallback() {
        if (this.track) return;
        this.track = this.querySelector('[data-fp-track]');
        if (!this.track) return;
        this.cards = Array.from(this.querySelectorAll('[data-fp-card]'));
        this.controls = this.querySelector('[data-fp-controls]');
        this.previous = this.querySelector('[data-fp-prev]');
        this.next = this.querySelector('[data-fp-next]');
        this.progress = this.querySelector('[data-fp-progress]');
        this.counter = this.querySelector('[data-fp-counter]');
        this.status = this.querySelector('[data-fp-status]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayEnabled = this.dataset.fpAutoplay === 'true';
        this.autoplayDelay = Math.max(2000, Number(this.dataset.fpAutoplayDelay) || 4000);
        this.autoplayDirection = 1;
        this.autoplayTimer = 0;
        this.pointerActive = false;
        this.inView = !('IntersectionObserver' in window);
        this.automaticMove = false;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.previous.addEventListener('click', () => this.userMove(-1), { signal });
        this.next.addEventListener('click', () => this.userMove(1), { signal });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.stopAutoplay();
          if (event.key === 'Home') this.goTo(0);
          else if (event.key === 'End') this.goTo(this.maximum);
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
          this.scheduleAutoplay();
        }, { signal });
        this.track.addEventListener('scroll', () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
          clearTimeout(this.announceTimer);
          this.announceTimer = setTimeout(() => {
            this.targetPosition = null;
            if (!this.automaticMove) this.status.textContent = this.counter.textContent;
            this.automaticMove = false;
          }, 180);
        }, { passive: true, signal });
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch') return;
          this.pointerActive = true;
          this.automaticMove = false;
          this.targetPosition = null;
          this.stopAutoplay();
        }, { passive: true, signal });
        this.track.addEventListener('pointerup', (event) => {
          if (event.pointerType !== 'touch') return;
          this.pointerActive = false;
          this.scheduleAutoplay();
        }, { passive: true, signal });
        this.track.addEventListener('pointercancel', (event) => {
          if (event.pointerType !== 'touch') return;
          this.pointerActive = false;
          this.scheduleAutoplay();
        }, { passive: true, signal });
        this.track.addEventListener('wheel', () => {
          this.automaticMove = false;
          this.targetPosition = null;
        }, { passive: true, signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopAutoplay();
          else this.scheduleAutoplay();
        }, { signal });
        this.motionChange = () => this.scheduleAutoplay();
        if (this.reduceMotion.addEventListener) {
          this.reduceMotion.addEventListener('change', this.motionChange);
        }
        this.resize = new ResizeObserver(() => {
          this.targetPosition = null;
          this.update();
          this.scheduleAutoplay();
        });
        this.resize.observe(this.track);
        if ('IntersectionObserver' in window) {
          this.intersection = new IntersectionObserver((entries) => {
            this.inView = Boolean(entries[0] && entries[0].isIntersecting);
            if (this.inView) this.scheduleAutoplay();
            else this.stopAutoplay();
          }, { threshold: 0.15 });
          this.intersection.observe(this);
        }
        this.setAttribute('data-fp-ready', '');
        this.update();
        this.scheduleAutoplay();
      }

      get position() { return Math.abs(this.track.scrollLeft); }
      get maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
      get direction() { return getComputedStyle(this.track).direction === 'rtl' ? -1 : 1; }
      get step() {
        if (this.cards.length < 2) return this.track.clientWidth;
        return Math.abs(this.cards[1].getBoundingClientRect().left - this.cards[0].getBoundingClientRect().left);
      }

      move(delta, automatic = false) {
        const current = this.targetPosition == null ? this.position : this.targetPosition;
        this.goTo((Math.round(current / this.step) + delta) * this.step, automatic);
      }

      goTo(position, automatic = false) {
        this.automaticMove = automatic;
        this.targetPosition = Math.min(this.maximum, Math.max(0, position));
        this.track.scrollTo({
          left: this.targetPosition * this.direction,
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      userMove(delta) {
        this.stopAutoplay();
        this.move(delta);
        this.scheduleAutoplay();
      }

      stopAutoplay() {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = 0;
      }

      scheduleAutoplay() {
        this.stopAutoplay();
        if (!this.autoplayEnabled || this.reduceMotion.matches || document.hidden) return;
        if (!this.inView || this.pointerActive || this.maximum < 2) return;
        this.autoplayTimer = setTimeout(() => this.autoMove(), this.autoplayDelay);
      }

      autoMove() {
        this.autoplayTimer = 0;
        const position = Math.min(this.maximum, Math.max(0, this.position));
        if (position >= this.maximum - 2) this.autoplayDirection = -1;
        else if (position <= 2) this.autoplayDirection = 1;
        this.move(this.autoplayDirection, true);
        this.scheduleAutoplay();
      }

      update() {
        if (!this.track || !this.cards.length) return;
        const maximum = this.maximum;
        const position = Math.min(maximum, Math.max(0, this.position));
        this.controls.hidden = maximum < 2;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= maximum - 2;
        const fraction = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
        this.progress.style.width = `${fraction * 100}%`;
        this.progress.style.transform = `translateX(${maximum ? position / maximum * (1 - fraction) / fraction * 100 : 0}%)`;
        const viewport = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index }))
          .filter(({ rect }) => Math.min(rect.right, viewport.right) - Math.max(rect.left, viewport.left) > rect.width * .5);
        if (visible.length) {
          const format = (value) => String(value).padStart(2, '0');
          const first = visible[0].index + 1;
          const last = visible[visible.length - 1].index + 1;
          this.counter.textContent = `${format(first)}${first === last ? '' : '–' + format(last)} / ${format(this.cards.length)}`;
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.abort) this.abort.abort();
        if (this.resize) this.resize.disconnect();
        if (this.intersection) this.intersection.disconnect();
        if (this.reduceMotion && this.reduceMotion.removeEventListener && this.motionChange) {
          this.reduceMotion.removeEventListener('change', this.motionChange);
        }
        cancelAnimationFrame(this.frame);
        clearTimeout(this.announceTimer);
        this.track = null;
        this.frame = 0;
        this.targetPosition = null;
        this.removeAttribute('data-fp-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foto-tekst-kontakt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('photo-text-contact')) {
    customElements.define('photo-text-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.slides = Array.from(this.querySelectorAll('[data-ftc-slide]'));
        if (this.slides.length < 2) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.generation = (this.generation || 0) + 1;
        this.failed = new Set();
        this.editorSelected = false;
        this.visible = !('IntersectionObserver' in window);
        this.delay = Math.max(3000, Number(this.dataset.interval) || 5000);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => this.schedule(), { signal });

        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.show(index);
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this.editorSelected = false;
          this.schedule();
        }, { signal });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.schedule();
          }, { threshold: 0 });
          this.observer.observe(this.querySelector('.ftc__media'));
        }
        this.schedule();
      }

      nextIndex() {
        for (let step = 1; step < this.slides.length; step++) {
          const next = (this.index + step) % this.slides.length;
          if (!this.failed.has(next)) return next;
        }
        return this.index;
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.editorSelected || this.motion.matches || document.hidden || !this.visible) return;
        const next = this.nextIndex();
        if (next !== this.index) this.timer = setTimeout(() => this.show(next), this.delay);
      }

      async show(index) {
        clearTimeout(this.timer);
        const generation = ++this.generation;
        if (index === this.index || this.failed.has(index)) { this.schedule(); return; }
        const image = this.slides[index].querySelector('img');
        if (image) {
          image.loading = 'eager';
          try { await image.decode(); } catch (_) { /* Keep the current photo if the next one fails. */ }
          if (!this.isConnected || generation !== this.generation) return;
          if (!image.naturalWidth) {
            this.failed.add(index);
            this.schedule();
            return;
          }
        }
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.index = index;
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.generation = (this.generation || 0) + 1;
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('full-screen-photo-hero')) {
  class FullScreenPhotoHero extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.scheduleSync = this.scheduleSync.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.scheduleSync, { passive: true });
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.scheduleSync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.scheduleSync);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.querySelectorAll('[data-fsh-video]').forEach((video) => this.deactivateVideo(video));
      cancelAnimationFrame(this.syncFrame);
    }

    onVisibilityChange() {
      if (document.hidden) {
        this.querySelectorAll('[data-fsh-video]').forEach((video) => this.deactivateVideo(video));
        return;
      }

      this.scheduleSync();
    }

    scheduleSync() {
      cancelAnimationFrame(this.syncFrame);

      this.syncFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;

        const width = document.documentElement.clientWidth;

        if (width > 0 && width !== this.viewportWidth) {
          this.viewportWidth = width;
          this.style.setProperty('--fsh-screen-width', width + 'px');
        }

        this.syncMedia(width <= 749);

        this.querySelectorAll('a[data-fsh-scroll]').forEach((link) => {
          const target = this.resolveTarget(link.dataset.fshScroll);

          if (target && target.id) {
            link.setAttribute('href', '#' + encodeURIComponent(target.id));
          }
        });
      });
    }

    syncMedia(useMobileMedia) {
      const activeKey = useMobileMedia ? 'mobile' : 'desktop';

      this.querySelectorAll('[data-fsh-media]').forEach((media) => {
        const video = media.querySelector('[data-fsh-video]');
        if (!video) return;

        const isActive = media.dataset.fshMedia === activeKey;

        if (!isActive || document.hidden) {
          if (video.dataset.fshActive === 'true') this.deactivateVideo(video);
          return;
        }

        this.prepareVideo(video);

        if (video.dataset.fshActive !== 'true') {
          media.classList.remove('is-video-playing');
          video.dataset.fshRestart = 'true';
        }

        video.dataset.fshActive = 'true';
        video.muted = true;
        video.defaultMuted = true;

        if (video.dataset.fshLoaded !== 'true') {
          if (video.dataset.poster) video.poster = video.dataset.poster;

          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
          });

          video.preload = 'auto';
          video.load();
          video.dataset.fshLoaded = 'true';
        }

        this.playVideoWhenReady(video);
      });
    }

    prepareVideo(video) {
      if (video.dataset.fshPrepared === 'true') return;
      video.dataset.fshPrepared = 'true';

      const media = video.closest('[data-fsh-media]');

      video.addEventListener('canplaythrough', () => {
        this.playVideoWhenReady(video);
      });

      video.addEventListener('playing', () => {
        if (video.dataset.fshActive === 'true' && media) {
          media.classList.add('is-video-playing');
        }
      });

      video.addEventListener('error', () => {
        if (media) media.classList.remove('is-video-playing');
      });
    }

    playVideoWhenReady(video) {
      if (
        video.dataset.fshActive !== 'true' ||
        document.hidden ||
        video.readyState < 4
      ) {
        return;
      }

      const media = video.closest('[data-fsh-media]');
      const cover = media && media.querySelector('[data-fsh-video-cover]');

      if (cover && !cover.complete) {
        if (video.dataset.fshWaitingCover !== 'true') {
          video.dataset.fshWaitingCover = 'true';

          const resume = () => {
            video.dataset.fshWaitingCover = 'false';
            this.playVideoWhenReady(video);
          };

          cover.addEventListener('load', resume, { once: true });
          cover.addEventListener('error', resume, { once: true });
        }
        return;
      }

      if (video.dataset.fshRestart === 'true') {
        try {
          video.currentTime = 0;
        } catch (error) {}
        video.dataset.fshRestart = 'false';
      }

      const playback = video.play();
      if (playback && typeof playback.catch === 'function') {
        playback.catch(() => {});
      }
    }

    deactivateVideo(video) {
      const media = video.closest('[data-fsh-media]');
      video.pause();
      video.dataset.fshActive = 'false';
      video.dataset.fshRestart = 'true';

      try {
        if (video.readyState >= 1) video.currentTime = 0;
      } catch (error) {}

      if (media) media.classList.remove('is-video-playing');
    }

    resolveTarget(value) {
      const selector = (value || 'next').trim() || 'next';

      if (
        selector.toLowerCase() === 'next' ||
        selector.toLowerCase() === '#next'
      ) {
        const wrapper = this.closest('.shopify-section') || this;
        const sections = Array.from(
          document.querySelectorAll('.shopify-section')
        );
        const current = sections.indexOf(wrapper);

        if (current >= 0) {
          for (let i = current + 1; i < sections.length; i++) {
            const candidate = sections[i];

            if (
              !wrapper.contains(candidate) &&
              candidate.getClientRects().length
            ) {
              return candidate;
            }
          }
        }

        return this.querySelector('[data-fsh-end]');
      }

      let id = selector.startsWith('#') ? selector.slice(1) : selector;

      try {
        id = decodeURIComponent(id);
      } catch (error) {}

      const byId = document.getElementById(id);
      if (byId) return byId;

      try {
        return document.querySelector(selector);
      } catch (error) {
        return null;
      }
    }

    onClick(event) {
      const link =
        event.target.closest &&
        event.target.closest('a[data-fsh-scroll]');

      if (!link || !this.contains(link) || event.defaultPrevented) return;

      const target = this.resolveTarget(link.dataset.fshScroll);

      if (target && target.id) {
        link.setAttribute('href', '#' + encodeURIComponent(target.id));
      }

      if (
        event.button > 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      if (window.Shopify && window.Shopify.inspectMode) return;

      event.preventDefault();

      if (!target || !target.getClientRects().length) {
        if (window.Shopify && window.Shopify.designMode) {
          console.warn(
            'Hero: cilj skrolovanja nije pronađen:',
            link.dataset.fshScroll
          );
        }
        return;
      }

      const targetStyle = getComputedStyle(target);
      const pageStyle = getComputedStyle(document.documentElement);
      const extra = Math.max(0, Number(this.dataset.scrollOffset) || 0);
      const margin = parseFloat(targetStyle.scrollMarginTop) || 0;
      const padding = parseFloat(pageStyle.scrollPaddingTop) || 0;

      const top = Math.max(
        0,
        window.scrollY +
          target.getBoundingClientRect().top -
          extra -
          margin -
          padding
      );

      if (
        typeof target.focus === 'function' &&
        target.getAttribute('aria-hidden') !== 'true'
      ) {
        const temporary = !target.matches(
          'a[href], button, input, select, textarea, [tabindex]'
        );

        if (temporary) {
          target.setAttribute('tabindex', '-1');

          target.addEventListener(
            'blur',
            () => {
              if (target.getAttribute('tabindex') === '-1') {
                target.removeAttribute('tabindex');
              }
            },
            { once: true }
          );
        }

        target.focus({ preventScroll: true });
      }

      window.scrollTo({
        top: top,
        left: window.scrollX,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'instant'
          : 'smooth'
      });
    }
  }

  customElements.define('full-screen-photo-hero', FullScreenPhotoHero);
}

  } catch(e) { console.error(e); }
})();
})();
